@if (canDisplay$ | async) {
  <button mat-icon-button (click)="undo()" [disabled]="undoUnavailable$ | async">
    <app-icon icon="undo"></app-icon>
  </button>
  <button mat-icon-button (click)="redo()" [disabled]="redoUnavailable$ | async">
    <app-icon icon="redo"></app-icon>
  </button>
}
